import React from 'react'
import styles from './AuditInfoPanel.module.css'
import QuestionSection from './QuestionSection'
import DefectsSection from './DefectsSection'
import ExamplesControls from './ExamplesControls'
import ExamplePhotoCarousel from './ExamplePhotoCarousel'

interface AuditInfoPanelProps {
  question: string
  defects: string[]
  sectionTitle: string
  exampleImages: string[]
  currentImageIndex: number
  isLoadingFailedExamples: boolean
  lookupAuditId: string
  setLookupAuditId: (id: string) => void
  isLoadingLookup: boolean
  onPreviousImage: () => void
  onNextImage: () => void
  onFetchFailedExamples: () => void
  onLookupAudit: () => void
}

function AuditInfoPanel({
  question,
  defects,
  sectionTitle,
  exampleImages,
  currentImageIndex,
  isLoadingFailedExamples,
  lookupAuditId,
  setLookupAuditId,
  isLoadingLookup,
  onPreviousImage,
  onNextImage,
  onFetchFailedExamples,
  onLookupAudit,
}: AuditInfoPanelProps) {
  return (
    <div className={styles.leftPanel}>
      <QuestionSection question={question} />
      <DefectsSection defects={defects} />
      <ExamplesControls
        isLoadingFailedExamples={isLoadingFailedExamples}
        lookupAuditId={lookupAuditId}
        setLookupAuditId={setLookupAuditId}
        isLoadingLookup={isLoadingLookup}
        onFetchFailedExamples={onFetchFailedExamples}
        onLookupAudit={onLookupAudit}
      />
      <ExamplePhotoCarousel
        exampleImages={exampleImages}
        currentImageIndex={currentImageIndex}
        sectionTitle={sectionTitle}
        onPreviousImage={onPreviousImage}
        onNextImage={onNextImage}
      />
    </div>
  )
}

export default AuditInfoPanel
